import OtpVerifyFlow from "./_OtpVerify";

export default class Common {
  /* ===================================
   *  CONSTRUCTOR
   * =================================== */
  constructor() {
    this.bindEvents();
  }

  /* ===================================
   *  EVENTS
   * =================================== */
  bindEvents() {
    // Screen Detection Setup
    this.ScreenDetectionSetup();

    // Smooth Scrolling Setup
    this.SmoothScrollSetup();

    // Back To Top Button Behavior
    this.BackToTop();

    // Header Change Style On scroll
    this.HeaderScrollEffect();

    // Common Slider Setup
    this.CommonSliderSetup();

    // Common Custom Select Setup
    this.SelectReStyleSetup();

    // Our Extensive Specialties Scroll Slides Setup
    // if ($("#our-extensive-specialties").length > 0) {
    //   this.SpecialtiesSliderSetup();
    // }

    // Modal Website
    if ($(".modal-wrapper").length > 0) {
      this.ModalControlSetup();
    }

    if ($("#emergency-modal").length > 0) {
      this.ModalFilterSetup();
    }

    if ($("#otp-verify-modal").length > 0) {
      window.HM_OTP_FLOW = new OtpVerifyFlow();
    }

    // Mobile Drawer Setup
    this.MobileDrawerSetup();

    // Mobile Menu Sub-menu Toggle Setup (for screens ≤ 1180px)
    this.MobileMenuToggleSetup();

    // Reload Button Setup
    this.ReloadButtonSetup();

    // Handle reload on specific breakpoint changes - DISABLED
    this.HandleBreakpointReload();

    // Floating Support Footer Trigger
    this.FloatingSupportFooterTrigger();
  }

  /* ===================================
   *  METHODS
   * =================================== */
  ScreenDetectionSetup() {
    // Set initial mobile state
    window.IS_MOBILE = window.innerWidth <= 1180;

    // Update on window resize
    $(window).on("resize", () => {
      window.IS_MOBILE = window.innerWidth <= 1180;
    });
  }

  // Smooth Scrolling
  SmoothScrollSetup() {
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();

            // get height menu for scroll exactly position of div
            var getHeightMenu = 52;
            if ($(window).width() < 767) {
              getHeightMenu = 62;
            }

            $("html, body").animate(
              {
                scrollTop: target.offset().top - getHeightMenu,
              },
              1000
            );
          }
        }
      });
  }

  // Back To Top Button
  BackToTop() {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $("#back-to-top").fadeIn();
      } else {
        $("#back-to-top").fadeOut();
      }
    });

    $("#back-to-top").click(function () {
      $("html, body").animate({ scrollTop: 0 }, 500);
      return false;
    });
  }

  // Header Scrolling Effect
  HeaderScrollEffect() {
    let $win = $(window),
      $header = $("header"),
      $quickAccess = $(".hm-quick-access"),
      $quickAccessBgOverlay = $(".quick-access-bg-overlay"),
      $homeBanner = $("#homepage-banner-slider-section"),
      $hospitalHomeBanner = $("#hospital-home-banner-section"),
      $firstSection = $("main section").first(),
      $footer = $(".page-footer"),
      $homepageMain = $(".homepage-main"),
      threshold,
      footerThreshold,
      lastScrollTop = 0,
      minScrollThreshold = 150; // Minimum scroll distance before applying effects

    // If hospital home banner exists, use it as the banner
    if ($hospitalHomeBanner.length) {
      $homeBanner = $hospitalHomeBanner;
    }

    // 1. Tính ngưỡng (offset top + height) của section đầu
    function updateThreshold() {
      if ($homeBanner.length) {
        threshold = $homeBanner.offset().top + $homeBanner.outerHeight();
      } else {
        threshold = $firstSection.offset().top + $firstSection.outerHeight();
      }

      // Tính ngưỡng footer - khi cạnh dưới màn hình chạm vào footer
      if ($footer.length) {
        footerThreshold = $footer.offset().top - $win.height();
      }
    }

    // 2. Khi scroll, kiểm tra và add/remove class
    function onScroll() {
      let scrollTop = $win.scrollTop();
      let windowHeight = $win.height();
      let isInFooterZone = false;

      // Disable quick-access toggle for screens <= 1180px
      if (window.innerWidth <= 1180) {
        return;
      }

      // Kiểm tra xem có đang trong vùng footer không
      if ($footer.length) {
        let footerTop = $footer.offset().top;
        isInFooterZone = scrollTop + windowHeight >= footerTop;
      }

      // Kiểm tra xem có phải trang chính (homepage) hoặc hospital home không
      if (
        ($homepageMain.length || $hospitalHomeBanner.length) &&
        $homeBanner.length
      ) {
        // Trang chính hoặc hospital home: ẩn quick-access khi banner còn visible
        if (scrollTop < threshold) {
          // Banner vẫn visible, luôn ẩn quick-access nhưng giữ header hiển thị
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
          $header.removeClass("header-is-hidden");
          lastScrollTop = scrollTop;
          return;
        }
        // Đã scroll qua banner, tiếp tục logic bình thường
      } else {
        // Trang khác: áp dụng ngưỡng 150px như cũ
        if (scrollTop < minScrollThreshold) {
          $quickAccess.removeClass("quick-access-is-hidden");
          $quickAccessBgOverlay.removeClass("quick-access-is-hidden");
          $header.removeClass("header-is-hidden");
          lastScrollTop = scrollTop;
          return;
        }
      }

      // Check if scrolling from TOC link - if so, prevent showing header/quick-access
      const isTOCScrolling = window.TOC_SCROLLING === true;

      // Logic cho các trường hợp sau khi đã scroll qua ngưỡng
      if (
        ($homepageMain.length || $hospitalHomeBanner.length) &&
        $homeBanner.length
      ) {
        // Logic riêng cho trang chính hoặc hospital home - phải hết banner mới bắt đầu có hiệu ứng
        if (scrollTop > threshold) {
          // Đã scroll qua banner, áp dụng logic bình thường
          if (isInFooterZone) {
            $quickAccess.addClass("quick-access-is-hidden");
            $quickAccessBgOverlay.addClass("quick-access-is-hidden");
            $header.addClass("header-is-hidden");
          } else {
            // Logic bình thường khi không trong vùng footer
            if (scrollTop > lastScrollTop) {
              $quickAccess.addClass("quick-access-is-hidden");
              $quickAccessBgOverlay.addClass("quick-access-is-hidden");
              $header.addClass("header-is-hidden");
            } else {
              // Only show header/quick-access if not scrolling from TOC
              if (!isTOCScrolling) {
                $quickAccess.removeClass("quick-access-is-hidden");
                $quickAccessBgOverlay.removeClass("quick-access-is-hidden");
                $header.removeClass("header-is-hidden");
              }
            }
          }
        } else {
          // Banner vẫn visible, luôn ẩn quick-access nhưng giữ header hiển thị
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
          $header.removeClass("header-is-hidden");
        }
      } else if ($homeBanner.length) {
        // Có banner nhưng không phải trang chính - áp dụng logic cũ
        if (scrollTop > threshold) {
          if (isInFooterZone) {
            $quickAccess.addClass("quick-access-is-hidden");
            $quickAccessBgOverlay.addClass("quick-access-is-hidden");
            $header.addClass("header-is-hidden");
          } else {
            if (scrollTop > lastScrollTop) {
              $quickAccess.addClass("quick-access-is-hidden");
              $quickAccessBgOverlay.addClass("quick-access-is-hidden");
              $header.addClass("header-is-hidden");
            } else {
              // Only show header/quick-access if not scrolling from TOC
              if (!isTOCScrolling) {
                $quickAccess.removeClass("quick-access-is-hidden");
                $quickAccessBgOverlay.removeClass("quick-access-is-hidden");
                $header.removeClass("header-is-hidden");
              }
            }
          }
        } else {
          // Banner is visible, always hide quick-access but keep header visible
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
          $header.removeClass("header-is-hidden");
        }
      } else {
        // Hoạt động bình thường nếu không có banner
        // Tính ngưỡng 80% chiều cao màn hình
        let scrollThreshold = windowHeight * 0.8;

        if (isInFooterZone) {
          // Nếu đang trong vùng footer, chỉ ẩn quick-access, không hiện lại
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
          $header.addClass("header-is-hidden");
        } else if (scrollTop > scrollThreshold) {
          // Chỉ áp dụng hiệu ứng khi scroll hết 80% chiều cao màn hình
          if (scrollTop > lastScrollTop) {
            $quickAccess.addClass("quick-access-is-hidden");
            $quickAccessBgOverlay.addClass("quick-access-is-hidden");
            $header.addClass("header-is-hidden");
          } else {
            // Only show header/quick-access if not scrolling from TOC
            if (!isTOCScrolling) {
              $quickAccess.removeClass("quick-access-is-hidden");
              $quickAccessBgOverlay.removeClass("quick-access-is-hidden");
              $header.removeClass("header-is-hidden");
            }
          }
        } else {
          // Khi scroll < 80% chiều cao màn hình, luôn ẩn quick-access, hiện header
          $quickAccess.addClass("quick-access-is-hidden");
          $quickAccessBgOverlay.addClass("quick-access-is-hidden");
          $header.removeClass("header-is-hidden");
        }
      }

      lastScrollTop = scrollTop;
    }

    // Khởi tạo
    updateThreshold();

    // Khởi tạo trạng thái ban đầu
    if (
      ($homepageMain.length || $hospitalHomeBanner.length) &&
      $homeBanner.length
    ) {
      // Trang chính hoặc hospital home: ẩn quick-access ngay từ đầu
      $quickAccess.addClass("quick-access-is-hidden");
      $quickAccessBgOverlay.addClass("quick-access-is-hidden");
      $header.removeClass("header-is-hidden");
    } else {
      // Trang khác: hiển thị header và quick-access từ đầu
      $quickAccess.removeClass("quick-access-is-hidden");
      $quickAccessBgOverlay.removeClass("quick-access-is-hidden");
      $header.removeClass("header-is-hidden");
    }

    onScroll();

    // Bắt event
    $win.on("scroll", onScroll).on("resize", function () {
      updateThreshold();
      onScroll();
    });
  }

  // Common Slider Setup
  CommonSliderSetup() {
    // Hospital Slider
    this.$hospitalSlider = $(".hospital-list-slider");
    if (this.$hospitalSlider.length > 0) {
      this.$hospitalSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: "",
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        autoplay: false,
        autoplaySpeed: 2000,
      });
    }

    // About Us Hospital List Slider
    this.$aboutUsHospitalSlider = $(".about-us-hospital-list-slider");
    if (this.$aboutUsHospitalSlider.length > 0) {
      this.$aboutUsHospitalSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        autoplay: false,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 460,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }

    // Development List Slider
    this.$developmentSlider = $(".development-list-slider");
    if (this.$developmentSlider.length > 0) {
      this.$developmentSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        autoplay: false,
        autoplaySpeed: 2000,
        lazyLoad: "ondemand",
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              rows: 2,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              rows: 1
            },
          },
        ],
      });
    }

    // News List Slider
    this.$newsListSlider = $(".news-list-slider");
    if (this.$newsListSlider.length > 0) {
      // Count number of slides
      const slideCount = this.$newsListSlider.find(
        ".news-slider-item, .slick-slide"
      ).length;

      // If less than 5 slides, use CSS grid instead of slider
      if (slideCount < 5) {
        this.$newsListSlider.addClass("news-list-grid");
      } else {
        // Initialize slider for 5+ items
        this.$newsListSlider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
          nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
          responsive: [
            {
              breakpoint: 1180,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                rows: 2,
              },
            },
            {
              breakpoint: 640,
              settings: "unslick",
            },
          ],
        });
      }
    }

    // Packages Slider
    this.$packagesSlider = $(".packages-list-slider");
    if (this.$packagesSlider.length > 0) {
      this.$packagesSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              rows: 2,
            },
          },
          {
            breakpoint: 640,
            settings: "unslick",
          },
        ],
      });
    }

    // Doctors Slider
    this.$doctorsSlider = $(".doctors-list-slider");
    if (this.$doctorsSlider.length > 0) {
      this.$doctorsSlider.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        responsive: [
          {
            breakpoint: 1180,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              rows: 2,
            },
          },
        ],
      });
    }

    // Edu Videos Slider
    this.$eduVideosSlider = $(".edu-videos-slider");
    if (this.$eduVideosSlider.length > 0) {
      this.$eduVideosSlider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: `<div class="slide-control slide-prev"><img src="${HM_Variables.assets_url}img/common/slide-prev-ico.svg" alt="Prev Button"></div>`,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              rows: 2,
            },
          },
        ],
      });
    }

    this.$ourSpecialtiesSlider = $(".our-specialties-slider");
    if (this.$ourSpecialtiesSlider.length > 0) {
      // Count number of specialty items
      const itemCount = this.$ourSpecialtiesSlider.find(
        ".specialty-slider-item"
      ).length;

      // Determine slidesToShow based on item count
      const desktopSlidesToShow = itemCount < 3 ? 2 : 4;

      this.$ourSpecialtiesSlider.slick({
        slidesToShow: desktopSlidesToShow,
        slidesToScroll: 1,
        prevArrow: "",
        // infinite: false,
        nextArrow: `<div class="slide-control slide-next"><img src="${HM_Variables.assets_url}img/common/slide-next-ico.svg" alt="Next Button"></div>`,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 640,
            settings: "unslick",
          },
        ],
      });
    }
  }

  SelectReStyleSetup() {
    // Track currently open select dropdown
    let $currentOpenSelect = null;

    // Function to update default-value class based on hidden input value
    const updateDefaultValueClass = function ($select) {
      const $currentValue = $select.find(".current-value");
      const $hiddenInput = $select.find("input[type='hidden']");
      const hiddenValue = $hiddenInput.val();

      if (
        hiddenValue === "" ||
        hiddenValue === null ||
        hiddenValue === undefined
      ) {
        $currentValue.addClass("default-value");
      } else {
        $currentValue.removeClass("default-value");
      }
    };

    // Handle custom select dropdowns
    $(".custom-select").each(function () {
      const $select = $(this);
      const $currentValue = $select.find(".current-value");
      const $optionsList = $select.find(".select-options-list");
      const $hiddenInput = $select.find("input[type='hidden']");

      // Initialize default-value class on page load
      updateDefaultValueClass($select);

      // Toggle dropdown on select click
      $select.on("click", function (e) {
        e.stopPropagation();

        if ($select.hasClass("is-disabled")) {
          return;
        }

        // Close any open dropdowns
        if ($currentOpenSelect) {
          $currentOpenSelect.removeClass("show");
        }

        // Open current dropdown
        $currentOpenSelect = $select.find(".select-options-list");
        $optionsList.addClass("show");
      });

      // Handle option selection using EVENT DELEGATION
      // Thay vì bind trực tiếp cho $options, bind cho $optionsList và delegate cho .option
      $optionsList
        .off("click.optionSelect")
        .on("click.optionSelect", ".option", function (e) {
          e.stopPropagation();
          const $option = $(this);
          const $allOptions = $optionsList.find(".option");
          const $customSelect = $option.closest(".custom-select");

          if (!$option.hasClass("active")) {
            // Update hidden input value
            $hiddenInput.val($option.data("value"));

            // Update displayed value with HTML content
            $currentValue.html($option.html());

            // Update active state
            $allOptions.removeClass("active");
            $option.addClass("active");

            // Update default-value class
            updateDefaultValueClass($customSelect);

            // Clear error message and styling for this select (for form validation)
            $customSelect.find(".err-msg").text("").removeClass("err");
            $customSelect.removeClass("err");

            $hiddenInput.trigger("change");
          }

          // Hide dropdown
          $optionsList.removeClass("show");
        });

      // Listen for programmatic changes to hidden input value
      $hiddenInput.on("change", function () {
        updateDefaultValueClass($select);
      });
    });

    // Close dropdown when clicking outside
    $(document).on("click", function () {
      if ($currentOpenSelect) {
        $currentOpenSelect.removeClass("show");
        $currentOpenSelect = null;
      }
    });
  }

  ModalControlSetup() {
    // VARIABLES
    this.$modalWrapper = $(".modal-wrapper");

    // EVENTS
    // Open Modal
    $(document).on("click", ".open-modal", (e) => {
      let $target = $(e.target);
      if ($target.parents(".open-modal").length > 0) {
        $target = $target.parents(".open-modal");
      }

      let targetModal = $target.data("target");
      let targetWrapper = $target.data("modal-wrapper");

      if (targetModal !== undefined && targetWrapper !== undefined) {
        // Find the specific modal wrapper
        let $targetWrapper = $(`#${targetWrapper}`);
        let $targetModal = $targetWrapper.find(
          `.modal-dialog[data-modal-id=${targetModal}]`
        );

        if ($targetModal.length > 0) {
          // Close any currently active modal in any wrapper
          $(".modal-dialog.active").removeClass("active");
          $(".modal-wrapper.show-modal").removeClass("show-modal");

          // Open Modal Behavior - only show the specific wrapper
          $("body").addClass("show-modal");
          $targetWrapper.addClass("show-modal");
          $targetModal.addClass("active");
        }
      }
    });

    // Close Modal
    $(document).on("click", ".close-modal", (e) => {
      if ($("#otp-verify-modal-wrapper").hasClass("is-processing")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      // Variables
      let $activeModal = $(".modal-dialog.active");
      let $activeWrapper = $(".modal-wrapper.show-modal");

      // Close Modal Behavior
      $("body").removeClass("show-modal");
      $activeWrapper.removeClass("show-modal");
      $activeModal.removeClass("active");
    });
  }

  MobileDrawerSetup() {
    // VARIABLES
    this.$mobileDrawer = $(".mb-drawer");
    this.$mobileMenuToggle = $(".mobile-menu-toggle");
    this.$closeDrawer = $(".close-drawer");
    this.$body = $("body");
    this.IsAnimating = false;

    // EVENTS
    // Toggle mobile menu
    $(document).on("click", ".mobile-menu-toggle", () => {
      // Flag to stop user from clicking multiple times
      if (this.IsAnimating) return;
      this.IsAnimating = true;

      setTimeout(() => {
        this.IsAnimating = false;
      }, 300);

      if (this.$mobileDrawer.hasClass("show-menu")) {
        // Close menu
        this.$body.addClass("show-menu");
        this.$mobileDrawer.removeClass("show-menu");
        this.$mobileMenuToggle.removeClass("show-menu");
      } else {
        // Open menu
        this.$body.addClass("show-menu");
        this.$mobileDrawer.addClass("show-menu");
        this.$mobileMenuToggle.addClass("show-menu");
      }
    });

    // Close menu when clicking close-drawer
    $(document).on("click", ".close-drawer", () => {
      this.$body.removeClass("show-menu");
      this.$mobileDrawer.removeClass("show-menu");
      this.$mobileMenuToggle.removeClass("show-menu");
    });

    // Close menu when window resizes to desktop view
    $(window).on("resize", () => {
      if (!window.IS_MOBILE && this.$mobileDrawer.hasClass("show-menu")) {
        this.$body.removeClass("show-menu");
        this.$mobileDrawer.removeClass("show-menu");
        this.$mobileMenuToggle.removeClass("show-menu");
      }
    });
  }

  /**
   * Mobile Menu Sub-menu Toggle Setup
   * Handles toggle functionality for sub-menus on mobile screens (≤ 1180px)
   */
  MobileMenuToggleSetup() {
    // Handle click on menu items with children (mobile only)
    $(document).on(
      "click",
      ".header-menu-mobile .menu-item-has-children",
      function (e) {
        // Only apply on mobile screens (≤ 1180px)
        if (window.innerWidth > 1180) return;

        const $menuItem = $(this);
        const $subMenu = $menuItem.find(".sub-menu");

        // Check if clicking on the link itself
        if ($(e.target).is("a")) {
          // If clicking on the main link, let it navigate normally
          return;
        }

        // Prevent default behavior for the menu item click
        e.preventDefault();
        e.stopPropagation();

        // Toggle sub-menu
        if ($menuItem.hasClass("sub-menu-open")) {
          // Close sub-menu
          $menuItem.removeClass("sub-menu-open");
          $subMenu.css("max-height", "0");
        } else {
          // Close other open sub-menus first
          $(".header-menu-mobile .menu-item-has-children.sub-menu-open").each(
            function () {
              $(this).removeClass("sub-menu-open");
              $(this).find(".sub-menu").css("max-height", "0");
            }
          );

          // Open current sub-menu
          $menuItem.addClass("sub-menu-open");

          // Calculate and set max-height for smooth animation
          const $subMenuItems = $subMenu.find("li");
          const itemHeight = 42; // Approximate height of each sub-menu item (32px line-height + 10px margin)
          const maxHeight = $subMenuItems.length * itemHeight;
          $subMenu.css("max-height", maxHeight + "px");
        }
      }
    );

    // Handle direct clicks on sub-menu links (allow navigation)
    $(document).on(
      "click",
      ".header-menu-mobile .menu-item-has-children .sub-menu a",
      function (e) {
        // Allow normal link navigation
        // No preventDefault() here - let the link work normally
      }
    );

    // Close all sub-menus when drawer closes
    $(document).on("click", ".close-drawer", () => {
      $(".header-menu-mobile .menu-item-has-children.sub-menu-open").each(
        function () {
          $(this).removeClass("sub-menu-open");
          $(this).find(".sub-menu").css("max-height", "0");
        }
      );
    });

    // Close sub-menus when screen size changes to desktop
    $(window).on("resize", () => {
      if (window.innerWidth > 1180) {
        $(".header-menu-mobile .menu-item-has-children.sub-menu-open").each(
          function () {
            $(this).removeClass("sub-menu-open");
            $(this).find(".sub-menu").css("max-height", "0");
          }
        );
      }
    });
  }

  // Modal Hospital Filter
  ModalFilterSetup() {
    // Get first brand item and its brand name for initial state
    const $firstBrandItem = $(
      "#emergency-modal .brands-list .brand-item"
    ).first();
    const initialBrandName = $firstBrandItem.data("brand-name");

    // Filter hospitals on page load for initial state
    $(".hospitals-list.modal-view .hospital-item").each(function () {
      if (!$(this).hasClass(initialBrandName)) {
        $(this).hide();
      }
    });

    // Filter locations on page load for initial state
    this.filterLocationsByBrand(initialBrandName);

    // Handle brand item click
    $(document).on(
      "click",
      "#emergency-modal .brands-list .brand-item",
      (e) => {
        // Update active state
        $(e.currentTarget).siblings().removeClass("active");
        $(e.currentTarget).addClass("active");

        // Get selected brand name
        const brandName = $(e.currentTarget).data("brand-name");

        // Filter hospitals by brand
        this.filterHospitalsByBrand(brandName);

        // Filter locations based on hospitals of this brand
        this.filterLocationsByBrand(brandName);

        // Reset location selection to "all"
        this.resetLocationSelection();
      }
    );

    // Handle location selection change
    $(document).on(
      "click",
      "#emergency-modal .location-select .option",
      (e) => {
        const $option = $(e.currentTarget);
        const $select = $option.closest(".location-select");

        // Prevent event bubbling
        e.stopPropagation();

        const locationId = $option.data("value");
        // console.log("Location option clicked:", locationeId);

        // Update active state
        $select.find(".option").removeClass("active");
        $option.addClass("active");

        // Update displayed value
        $select
          .find(".current-value")
          .html($option.text().trim())
          .removeClass("default-value");

        // Update hidden input
        $select.find("input[name='location_modal_filter']").val(locationId);

        // Trigger change event on hidden input
        $select.find("input[name='location_modal_filter']").trigger("change");

        // Filter hospitals by selected location and current brand
        this.filterHospitalsByLocationAndBrand(locationId);

        // Close dropdown
        $select.find(".select-options-list").removeClass("show");
      }
    );

    // Backup: Handle change event on hidden input
    $(document).on("change", 'input[name="location_modal_filter"]', (e) => {
      const locationId = $(e.target).val();
      // console.log("Location input changed:", locationId);
      this.filterHospitalsByLocationAndBrand(locationId);
    });
  }

  /**
   * Filter hospitals by brand
   * @param {string} brandName - The brand short name
   */
  filterHospitalsByBrand(brandName) {
    $(".hospitals-list.modal-view .hospital-item").each(function () {
      if ($(this).hasClass(brandName)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }

  /**
   * Filter locations based on hospitals of the selected brand
   * @param {string} brandName - The brand short name
   */
  filterLocationsByBrand(brandName) {
    // Get all visible hospitals of this brand
    const brandHospitalLocations = [];
    $(".hospitals-list.modal-view .hospital-item").each(function () {
      if ($(this).hasClass(brandName)) {
        const locationId = $(this).data("hospital-location");
        // console.log(
        //   "Hospital location data:",
        //   locationId,
        //   "for brand:",
        //   brandName
        // );
        if (locationId && !brandHospitalLocations.includes(locationId)) {
          brandHospitalLocations.push(locationId);
        }
      }
    });

    // console.log("Brand hospital locations:", brandHospitalLocations);

    // Filter location options
    const $locationOptions = $(
      "#emergency-modal .location-select .select-options-list .option"
    );
    $locationOptions.each(function () {
      const $option = $(this);
      const optionValue = $option.data("value");

      // Always show the "All" location option
      if (optionValue === "all") {
        $option.show();
        return;
      }

      // Show location if it has hospitals of this brand
      if (brandHospitalLocations.includes(optionValue)) {
        $option.show();
      } else {
        $option.hide();
      }
    });
  }

  /**
   * Filter hospitals by location and current brand
   * @param {string} locationId - The location ID or "all"
   */
  filterHospitalsByLocationAndBrand(locationId) {
    // console.log("=== filterHospitalsByLocationAndBrand called ===");
    // console.log("Location ID:", locationId);

    // Get current active brand
    const activeBrand = $(
      "#emergency-modal .brands-list .brand-item.active"
    ).data("brand-name");
    // console.log("Current active brand:", activeBrand);
    // console.log("Selected location:", locationId);

    // First, reset all hospitals to show only those belonging to current brand
    $(".hospitals-list.modal-view .hospital-item").each(function () {
      const $hospital = $(this);
      const belongsToBrand = $hospital.hasClass(activeBrand);

      if (belongsToBrand) {
        $hospital.show();
      } else {
        $hospital.hide();
      }
    });

    // If "all" is selected, we're done (all hospitals of current brand are already shown)
    if (locationId === "all") {
      return;
    }

    // Now filter by location for hospitals of current brand
    $(".hospitals-list.modal-view .hospital-item").each(function () {
      const $hospital = $(this);

      // Skip if hospital doesn't belong to current brand (already hidden)
      if (!$hospital.hasClass(activeBrand)) {
        return;
      }

      // Check if hospital is in selected location
      const hospitalLocation = $hospital.data("hospital-location");
      // console.log(
      //   "Hospital:",
      //   $hospital.find("h3").text(),
      //   "Location:",
      //   hospitalLocation,
      //   "Selected:",
      //   locationId,
      //   "Match:",
      //   hospitalLocation == locationId
      // );

      if (hospitalLocation == locationId) {
        $hospital.show();
      } else {
        $hospital.hide();
      }
    });
  }

  /**
   * Reset location selection to default state
   */
  resetLocationSelection() {
    const $locationSelect = $("#emergency-modal .location-select");
    const $locationCurrentValue = $locationSelect.find(".current-value");
    const $locationHiddenInput = $locationSelect.find(
      "input[name='location_modal_filter']"
    );
    const lang = window.HM_Variables.language;

    // Clear the hidden input value
    $locationHiddenInput.val("");
    // Reset the displayed text to the default placeholder
    $locationCurrentValue
      .html(lang === "vi" ? "Chọn tỉnh thành" : "Choose location")
      .addClass("default-value");
    // Remove active class from all options
    $locationSelect.find(".option").removeClass("active");
    // Set the "All" option as active
    $locationSelect.find(".option[data-value='all']").addClass("active");
  }

  // Handle reload on specific breakpoint changes - REMOVED
  // Track previous width to detect crossing breakpoint
  HandleBreakpointReload() {
    let prevWidth = window.innerWidth;

    $(window).on("resize", () => {
      const currentWidth = window.innerWidth;
      const breakpoint = 900;

      // Only reload if crossing the breakpoint threshold
      if (
        (prevWidth > breakpoint && currentWidth <= breakpoint) ||
        (prevWidth <= breakpoint && currentWidth > breakpoint)
      ) {
        window.location.reload();
      }

      prevWidth = currentWidth;
    });
  }

  /**
   * Reload Button Setup
   * Handles click events on elements with .reload-btn class to reload the current page
   */
  ReloadButtonSetup() {
    $(document).on("click", ".reload-btn", function (e) {
      e.preventDefault();
      window.location.reload();
    });
  }

  /**
   * Floating Support Footer Trigger
   * Uses Intersection Observer to watch when footer reaches 15% from the bottom
   * of the viewport and modifies floating-support element accordingly
   */
  FloatingSupportFooterTrigger() {
    const $floatingSupport = $(".floating-support");
    const $footer = $(".page-footer, footer");

    if (!$floatingSupport.length || !$footer.length) {
      return;
    }

    const observerOptions = {
      root: null, // viewport
      rootMargin: "-70% 0px 0px 0px",
      threshold: 0.3,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          $floatingSupport.addClass("footer-visible");
        } else {
          $floatingSupport.removeClass("footer-visible");
        }
      });
    };

    // Create and start observing
    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );
    observer.observe($footer[0]);
  }
}
